import React, { useState, useEffect } from "react";
import { User11 } from "../../imagepath";
import { Link } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";
import { uploadFile, getFile, removeFile } from "../../../lib/file";
import { useAuth } from "../../../usercontext";
import { updateData } from "../../../lib/profiles";
import { clippingParents } from "@popperjs/core";

export default function StudentProfile() {
  const [studentInfo, setStudentInfo] = useState();
  console.log("stu", studentInfo);
  const [selectedImage, setSelectedImage] = useState();
  const [avatar, setAvatar] = useState("");
  const { profile, setProfile } = useAuth();

  async function ChangePhoto() {
    let file = selectedImage;
    let fileExt = file.name.split(".")[file.name.split(".").length - 1];
    let newFileName = profile.id + "." + fileExt;

    await uploadFile(newFileName, selectedImage);

    await updateData({
      id: profile.id,
      avatar_url: newFileName,
    });

    clippingParents;
    setProfile({
      ...profile,
      avatar_url: newFileName,
    });

    await removeFile(profile.avatar_url);
  }

  async function GetData() {
    if (profile) {
      const info = await getIdData(profile.id);
      setStudentInfo(info);
      const avt = await getFile(profile.avatar_url);
      setAvatar(avt.publicUrl);
    }
  }

  useEffect(() => {
    GetData();
    //console.log("EditProfile",profile);
  }, [profile]);


  const isStudent911 = profile?.role === "Student911";
  const isStudent12 = profile?.role === "Student12";

  return (
    <div className="col-12">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-0">
          <div className="profile-heading">
            <h3>Profile Details</h3>
          </div>
          <div className="course-group mb-0 d-flex">
            <div className="course-group-img d-flex align-items-center">
              <Link to="/students-profile">
                {selectedImage ? (
                  <img
                    src={URL.createObjectURL(selectedImage)}
                    alt=""
                    className="img-fluid"
                  />
                ) : (
                  <img
                    src={avatar ? avatar : User11}
                    alt=""
                    className="img-fluid"
                  />
                )}
              </Link>
              <div className="course-name">
                <h4>
                  <Link to="/">Your avatar</Link>
                </h4>
                <p>PNG or JPG no bigger than 800px wide and tall.</p>
              </div>
            </div>
            <div className="profile-share d-flex align-items-center justify-content-center">
              <div className="relative-form">
                <span>No File Selected</span>
                <label className="relative-file-upload">
                  Change Photo{" "}
                  <input
                    type="file"
                    name="myImage"
                    onChange={(event) => {
                      //console.log(event.target.files[0]);
                      setSelectedImage(event.target.files[0]);
                    }}
                  />
                </label>
              </div>
              <button onClick={ChangePhoto} className="btn btn-success">
                Update
              </button>
              {/*}
                      <Link to="#;" className="btn btn-success">
                        Update
                      </Link>
                      <Link to="#;" className="btn btn-danger">
                        Delete
                      </Link>
                      */}
            </div>
          </div>
          <div className="settings-widget">
            <div className="settings-inner-blk p-0">
              <div className="checkout-form personal-address add-course-info">
                <div className="personal-info-head">
                  <h4>Student Details</h4>
                </div>
                <form action="#">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">First Name</label>
                        <p>{studentInfo ? studentInfo[0].name : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">Last Name</label>
                        <p>{studentInfo ? studentInfo[0].surname : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">Phone</label>
                        <p>{studentInfo ? studentInfo[0].phone : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">
                          Grade Level
                        </label>
                        <p>{studentInfo ? studentInfo[0].class : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">Email</label>
                        <p>{studentInfo ? studentInfo[0].email : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">
                          School Name
                        </label>
                        <p>{studentInfo ? studentInfo[0].schoolname : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Nick Name</label>
                        <p>{studentInfo ? studentInfo[0].username : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">
                          Graduation year
                        </label>
                        <p>{studentInfo ? studentInfo[0].graduateyear : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          GPA: Weighted and unweighted GPA if known
                        </label>
                        <p>{studentInfo ? studentInfo[0].gpa : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">
                          SAT and or PSAT scores and the date of testing
                        </label>
                        <p>{studentInfo ? studentInfo[0].satpsat : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Practice SAT: Official practice SAT score and the date
                          of testing
                        </label>
                        <p>{studentInfo ? studentInfo[0].statetest : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">
                          Major: What do you want to study in college?
                        </label>
                        <p>{studentInfo ? studentInfo[0].major : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Career: What do you want to do after college?
                        </label>
                        <p>{studentInfo ? studentInfo[0].career : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Five Adjectives:five character trait adjectives that
                          describe you the most
                        </label>
                        <p>
                          {studentInfo ? studentInfo[0].fiveAdjectives : ""}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          About my high school
                        </label>
                        <p>
                          {studentInfo ? studentInfo[0].hsSchoolStatistics : ""}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Desired Colleges Top three college choices
                        </label>
                        <p>
                          {studentInfo ? studentInfo[0].topThreeColleges : ""}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Letter of Recommendation: Did you get one? It so,
                          which teacher wrote it
                        </label>
                        <p>{studentInfo ? studentInfo[0].lor : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Activities: List all activities outside of your high
                          school hours
                        </label>
                        <p>{studentInfo ? studentInfo[0].activities : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          College Essay: What progress have you made on your
                          essay so far?
                        </label>
                        <p>{studentInfo ? studentInfo[0].collegeEssay : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Counselor&apos;s Comment
                        </label>
                        <p>
                          {studentInfo ? studentInfo[0].instructorNote : ""}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">
                          Student&apos;s Comment
                        </label>
                        <p>{studentInfo ? studentInfo[0].studentNote : ""}</p>
                      </div>
                    </div>
                    <div className="update-profile d-flex justify-content-between">
                      <Link
                        className="btn btn-primary"
                        to={isStudent911 ?  "/student911/student-profile-edit" : "/student12/student-profile-edit"}
                        
                      >
                        Update Profile
                      </Link>

                      <Link to="/newpassword" className="btn btn-warning">
                        Change Password
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
